import { Component } from '@angular/core';

@Component({
  selector: 'app-yamc',
  templateUrl: './yamc.component.html',
  styleUrl: './yamc.component.css'
})
export class YamcComponent {

}
